// extracted by mini-css-extract-plugin
export default {"remove":"SurveySelectorQuestion_remove__ynW8M","add":"SurveySelectorQuestion_add__fGN39","delete":"SurveySelectorQuestion_delete__KN+wG","grid":"SurveySelectorQuestion_grid__ea4LZ"};